<template>
      <div class="panel panel-default" style="border:1px solid #ccc; background-color:white;">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="javascript://void(0)" @click="toggleShowAll">
              Question
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </a>
          </h4>
        </div>
        <div class="panel-collapse" :class="{ collapse: this.showSection }" style="background-color:white;">
          <div class="panel-body" style="background-color:white;">Answer</div>
        </div>
      </div>
</template>

<script>
export default {
  // props: {
  //   showSection: {
  //     type: Boolean,
  //     default: true,
  //   },
  // },
  methods: {
    toggleShowAll() {
      this.showSection = !this.showSection;
    },
  },
  computed: {
    faded() {
      if (this.showSection) {
        return "";
      } else {
        return "in";
      }
    },
  },
  data() {
    return {
      showSection: false,
    };
  },
};
</script>
